module.exports = __webpack_public_path__ + "img/hjsc.10c2de7b.svg";